module.exports = __webpack_public_path__ + "static/media/Muli-Light.669dcbe4.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-Light.ttf
// module id = 1292
// module chunks = 1